import { PageHeader, PageHeaderProps } from 'antd';
import React, { FC } from 'react';

export const ILSPageHeader: FC<PageHeaderProps> = (props) => {
  return <PageHeader {...props} />;
};
